/* istanbul ignore file */
import { css } from 'styled-components';

/*
  Sizes are the two slots this badge sits in: the modal's 90px thumbnail rail, and a full
  media poster (a carousel slide or an on-page grid tile). Fixed pixel sizes rather than a
  scale token because the badge has to stay legible without dominating the poster it covers.
*/
const SIZES = {
  sm: { circle: 24, glyph: 10 },
  lg: { circle: 48, glyph: 18 },
} as const;

export const root = css`
  /* Centres itself over the nearest positioned ancestor, so consumers need no layout CSS. */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  /* Sits over photography of any colour, so the contrast comes from the badge itself
     rather than a theme surface token. */
  background-color: rgb(0 0 0 / 60%);
  color: #fff;
  pointer-events: none;

  &[data-size='sm'] {
    width: ${SIZES.sm.circle}px;
    height: ${SIZES.sm.circle}px;
  }

  &[data-size='lg'] {
    width: ${SIZES.lg.circle}px;
    height: ${SIZES.lg.circle}px;
  }

  &[data-size='sm'] svg {
    width: ${SIZES.sm.glyph}px;
    height: ${SIZES.sm.glyph}px;
  }

  &[data-size='lg'] svg {
    width: ${SIZES.lg.glyph}px;
    height: ${SIZES.lg.glyph}px;
  }
`;
